import SectionHeader from "../../../util/component/SectionHeader";
import { Box, useTheme } from "@mui/material";
import AccountsSearch from "../component/AccountsSearch";
import AccountsTable from "../component/AccountsTable";
import { useTranslation } from "react-i18next";

function AccountsList() {
  const theme = useTheme();
  const {t} = useTranslation("corporateidp");
  return (
    <>
      <SectionHeader title={t('list.title')} />
      <Box p={theme.spacing(2)}>
        <AccountsSearch />
        <AccountsTable />
      </Box>
    </>
  );
}


export default AccountsList;
